import { useMemo } from "react";

import { OrganizationRoles, Roles } from "@/shared/utils/constants";
import { canManageRole } from "@/shared/utils/roles";
import { MembershipResponse } from "@/redux/memberships/types";
import { MemberPermissions } from "@/features/organizations/profile/types";
import { FullUserResponse } from "@/redux/users/types";

export const useMemberPermissions = (
  member: MembershipResponse | null | undefined,
  currentUser: FullUserResponse | null | undefined,
): MemberPermissions => {
  return useMemo(() => {
    if (!currentUser) {
      return {
        canEdit: false,
        canDelete: false,
        canCreate: false,
        canImpersonate: false,
      };
    }

    const isAppAdmin = currentUser.role === Roles.ADMIN.value;
    const isAdmin =
      currentUser.organizationRole === OrganizationRoles.ADMIN.value;
    const isSupervisor =
      currentUser.organizationRole === OrganizationRoles.SUPERVISOR.value;
    const isMemberOfOrganization =
      member && currentUser.organization?.id === member.organization;

    const canManageMember = Boolean(
      isMemberOfOrganization &&
        (isAdmin || isSupervisor) &&
        canManageRole(currentUser.organizationRole, member?.role),
    );

    const canCreate = isAdmin || isAppAdmin;
    const canEdit = canManageMember || isAppAdmin;
    const canDelete = canManageMember || isAppAdmin;

    return {
      canEdit,
      canDelete,
      canCreate,
      canImpersonate: currentUser.isSuperuser,
    };
  }, [member, currentUser]);
};
